<script>
import MixedGridVideoItem from '@phoenix/mixins/components/mixedGrid/MixedGridVideoItem';
import BackgroundVideo from '@maison/components/molecules/BackgroundVideo.vue';

export default {
  components: { BackgroundVideo },

  mixins: [MixedGridVideoItem],

  computed: {
    containerClasses() {
      return ['product-cards__poster', 'sgphx'].concat(this.displayClasses);
    },
  },
};
</script>

<template>
  <div :class="containerClasses">
    <background-video :video-id="itemId" :video-src="video" :poster-src="poster" is-loop />
  </div>
</template>
